import React, { Component } from 'react';
import Switch from '@material-ui/core/Switch';


import './SettingSwitchs.css';

export default class SettingSwitchs extends Component {

  validator = (name) => {
    if (name === 'dark') {
      this.props.setDark();
    } else {
      this.props.setNotif();
    }
  }
  render() {
    return (
      <div className="mobile-setting-switch d-flex">
        <div>{this.props.switchs.title}</div>
        <Switch
          // checked={this.props.switchs.value}
          color="primary"
          name={this.props.switchs.name}
          inputProps={{ 'aria-label': 'primary checkbox' }}
          onChange={(e) => this.validator(this.props.name)}
          disabled
        />
      </div>
    );
  }
}